import { SxProps, Theme } from '@mui/material/styles';

export const radioSx: SxProps<Theme> = {};
